export const VOLUNTEER_POST_TYPES = [
  { value: 'general', label: 'General' },
  { value: 'education', label: 'Education and training' },
  { value: 'women', label: 'Women empowerment' },
  { value: 'elders', label: 'Elder support' },
  { value: 'disaster', label: 'Disaster relief' },
];

export const VOLUNTEER_TYPE_HINTS = {
  education: 'Training or a learning session in this area.',
  women: 'For the Jagat Janani Matru Shakti wing.',
  elders: 'For the Samaj Pathdarshak Vadilvrund wing.',
  disaster: 'Useful skills include First Aid, Medical, and Logistics.',
};

export function volunteerTypeLabel(value) {
  const match = VOLUNTEER_POST_TYPES.find((item) => item.value === value);
  return match ? match.label : 'General';
}
